// import { v4 as uuidV4 } from "uuid";

export const snackbar = {
  state: {
    messages: [],
  },
  reducers: {
    add(state, message) {
      return { ...state, messages: [...state.messages, message] };
    },
    remove(state, id) {
      const messages = state.messages.filter((row) => row.id !== id);
      return { ...state, messages };
    },
  },
  effects: (dispatch) => ({}),
};
